import { Guid } from '@fitscovery/common/types';
import { PartnerData, ContactInfo, ImageDescription, PartnerConfig, SocialMediaLink, TextSection, PartnerSettings } from '../models';

export class GetPartnerBySubdomain {
  static readonly type = '[Partner] GetPartnerBySubdomain';

  constructor(public subdomain: string) { }
}

export class GetPartnerById {
  static readonly type = '[Partner] GetPartnerById';

  constructor(public id: Guid) { }
}

export class CreatePartnerWebsite {
  static readonly type = '[Partner] CreatePartnerWebsite';

  constructor(public partnerData: PartnerData) { }
}

export class UpdateLogoImage {
  static readonly type = '[Partner] UpdateLogoImage';

  constructor(public partnerId: Guid, public logoUrl: string) { }
}

export class UpdateImageDescriptions {
  static readonly type = '[Partner] UpdateImageDescriptions';

  constructor(public partnerId: Guid, public media: ImageDescription[]) { }
}

export class UpdateAppConfig {
  static readonly type = '[Partner] UpdateAppConfig';

  constructor(public appConfig: PartnerConfig) { }
}

export class UpdateTextSections {
  static readonly type = '[Partner] UpdateTextSections';

  constructor(public partnerId: Guid, public textSections: TextSection[]) { }
}

export class UpdateSocialMedia {
  static readonly type = '[Partner] UpdateSocialMedia';

  constructor(public partnerId: Guid, public socialMedia: SocialMediaLink[]) { }
}

export class UpdateContactInfo {
  static readonly type = '[Partner] UpdateContactInfo';

  constructor(public contactInfo: ContactInfo) { }
}

export class UpdatePartnerSettings {
  static readonly type = '[Partner] UpdatePartnerSettings';

  constructor(public partnerId: Guid, public settings: PartnerSettings) { }
}
